import React, { memo, useEffect, useState } from 'react';
import { StyAlert } from 'routes/HumanResourcesModule/components/ui/StyAlert';
import { useHypothesesChangesContext } from './contexts/HypothesesChangesContext';

const HypothesisChangeInfoAlert = ({
    text,
}: {
    text: string;
}): React.ReactElement => {
    const [show, setShow] = useState(true);
    const { hasChanges } = useHypothesesChangesContext();

    useEffect(() => {
        setShow(hasChanges);
    }, [hasChanges]);

    if (!show) return <></>;
    return (
        <StyAlert severity="info" onClose={() => setShow(false)}>
            {text}
        </StyAlert>
    );
};

export default memo(HypothesisChangeInfoAlert);
